export default __webpack_public_path__ + "static/media/de.ab6a18e7.png";